import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fieldKey", "module"];
import { Component } from 'react';
import { pick } from 'underscore';
import Routes from 'ContentUtils/Routes';
import { View } from 'foundations-components/transitional/components/View';
import OccurrenceLabel from 'ContentComponents/components/cmv2/occurrences/OccurrenceLabel';
import { getFieldFromKey } from 'ContentComponents/components/cmv2/utils';
import { isOccurrenceKey } from 'ContentComponents/components/cmv2/utils/occurrence';
import { getGroupValue, getGroupValueFromKey } from 'ContentComponents/components/cmv2/utils/fieldGroup';
import { RESOURCES_TO_FETCH_BY_TYPE } from 'ContentComponents/components/cmv2/constants';
import { getDeepValue, isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
class FieldKeyLabel extends Component {
  get fields() {
    const {
      fields,
      moduleSpec
    } = this.props;
    return fields || moduleSpec.fields;
  }
  render() {
    const _this$props = this.props,
      {
        fieldKey,
        module
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const field = getFieldFromKey(this.fields, fieldKey) || {};

    // If editing an occurrence of a field, use the occurrence's value
    if (isOccurrenceKey(fieldKey)) {
      let value = getDeepValue(module, fieldKey);
      if (Routes.isUngated('Cms:FixDefaultValuesInGroups')) {
        const groupValue = getGroupValue(this.fields, fieldKey, module);
        if (value === undefined && !isNullOrUndefined(groupValue)) {
          value = getGroupValueFromKey(groupValue, fieldKey);
        }
      }
      if (value === undefined && !isNullOrUndefined(field.default)) {
        const occurrenceData = getDeepValue(field.default, fieldKey.slice(1));
        value = [occurrenceData];
      }
      const resources = pick(rest, Object.values(RESOURCES_TO_FETCH_BY_TYPE || {}));
      return /*#__PURE__*/_jsx(OccurrenceLabel, {
        asString: true,
        defaultLabel: field.label || `${value}`,
        field: field,
        resources: resources,
        value: value
      });
    }
    return /*#__PURE__*/_jsx(View, {
      as: "span",
      children: field.label
    });
  }
}
export default FieldKeyLabel;